import { useQuery } from "@apollo/client";
import { GET_INFOS } from "./graphql";
import { InfoList } from "./list";

export const InfoPage = () => {
  const { data, refetch } = useQuery(GET_INFOS);
  const sorted = [...(data?.infos ?? [])].sort(
    (a, b) => (a?.order ?? 0) - (b?.order ?? 0)
  );

  return <InfoList infos={sorted} refetch={refetch} />;
};
